import type { UserRole } from '../../types';
import { useSession } from '../../state/session';
import { Icon } from '../ui/Icon';
import styles from './RoleSwitch.module.css';

const OPTIONS: { role: UserRole; label: string; icon: 'shield' | 'user' | 'gamepad' }[] = [
  { role: 'owner', label: 'Owner', icon: 'shield' },
  { role: 'manager', label: 'Manager', icon: 'user' },
  { role: 'client', label: 'Client', icon: 'gamepad' },
];

/**
 * Preview-only affordance to flip between the Dashboard (owner) and the game
 * (client) without a Discord session. It renders nothing inside Discord, where
 * the role is enforced by the backend.
 */
export function RoleSwitch() {
  const { mode, role, setPreviewRole } = useSession();

  if (mode !== 'preview') return null;

  return (
    <div className={styles.dock} role="group" aria-label="Preview role">
      <span className={styles.label}>
        <Icon name="swap" size={13} />
        View as
      </span>
      <div className={styles.segments}>
        {OPTIONS.map((option) => (
          <button
            key={option.role}
            type="button"
            className={`${styles.segment} ${role === option.role ? styles.active : ''}`}
            onClick={() => setPreviewRole(option.role)}
            aria-pressed={role === option.role}
          >
            <Icon name={option.icon} size={14} />
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
